// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inform {
  height: 2rem;
  width: 25vw;
  margin-left: 1rem;
}

/* hover effect */
.icon-wrapper:hover .arrow-icon {
  transform: scale(1.15);
}

.checkbox {
  height: 1.5rem;
  width: 1.5rem;
}

;

.checkbox__checked {
  background-color: blue;
}

;

.table1 {
  font-size: small;
  display: flex;
}

thead {
  text-align: center;
  word-wrap: normal;
}

tbody {
  text-align: center;
  word-wrap: normal;
}

tr {
  font-size: small;
  border: 5px transparent solid;

}

td {
  border-top: 1px solid black;
  border: 8px solid transparent;
  word-wrap: normal;
}

.spclbtn {
  color: rgb(255, 81, 0);
  border: 1px rgb(255, 81, 0) solid;
  border-radius: 4px;
}

.spclbtn:hover {
  background-color: rgb(255, 81, 0);
  color: white;
}

.midheader {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: end;
  height: 16rem;
}

.midheadersibling {
  display: grid;
  border: none;
  border-radius: 20px;
  padding: 20px;
  background-color: pink;
  position: relative;
  bottom: 12.5rem;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-expand 0.5s ease-in-out;
  }
}

@keyframes App-logo-expand {
  from {
    width: 0;
    /* start with no width */
    opacity: 0;
    /* start with no opacity */
    scale: 0;
  }

  to {
    width: 100%;
    /* expand to full width */
    opacity: 1;
    /* fully visible */
    scale: 100%;
  }
}

.react-datepicker__day:hover {
  background-color: #f0f4ff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
}

.react-datepicker__day--selected {
  background-color: #4a90e2 !important;
  color: white;
}

.react-datepicker__day--disabled {
  color: #ccc !important;
  cursor: not-allowed;
}

.react-datepicker-wrapper {
  border: none !important;
  outline: none !important;
}

.react-datepicker__input-container input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  /* Remove shadow if any */
}

/* Table styles */
.table-container {
  padding: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

/* Header styles */
.th {
  padding: 12px;
  text-align: left;
  background-color: #f4f4f4;
  border-bottom: 1px solid #ddd;
}

/* Cell styles */
.td {
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

/* Progress bar container */
.progress-container {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  height: 10px;
}

/* Dynamic progress bar based on value */
.progress {
  height: 10px;
  border-radius: 5px;
}

/* Color for different progress levels */
.progress.high {
  background-color: #4caf50;
}

.progress.medium {
  background-color: #ffeb3b;
}

.progress.low {
  background-color: #f44336;
}

.c12 {
  display: flex;
  justify-content: space-between;
  background-color: #e2e8f0;
  padding: 20px;
  border-radius: 15px;
  flex-wrap: wrap;
  gap: 10px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .col-12 {
    justify-content: center;
    gap: 15px;
  }
}

/* Dashboard.css */

.dashboard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.dashboard-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}

.date-picker-container {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  max-width: 600px;
}

.date-picker {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.form-label {
  font-weight: 600;
  margin-bottom: 5px;
}

.form-control {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
}

.tableContainer {
  width: 96%;

  table {
    width: 100%;
    border: 1px solid #0094DE;


    tr,
    th,
    td {
      padding: 10px;
    }

    th,
    td {
      border: 2px solid #78c0e4 !important;
      font-size: 12px;

    }

    thead {
      tr {
        background-color: #0094DE;
        color: white;

        th {
          font-weight: 500 !important;
        }
      }
    }

    tbody {
      tr {
        td {
          td {
            font-weight: 400 !important;
          }
        }
      }
    }

  }
}

.boxShadow {
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.258);
  background-color: #FFFFFF;
  padding: 0px 0px 10px 0px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.modal-content-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  width: 610px;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/page.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;AAGf;;AAAA;;AAEA;EACE,sBAAsB;AAGxB;;AAAA;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;;AAE/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,QAAQ;IACR,wBAAwB;IACxB,UAAU;IACV,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;;EAEV;IACE,WAAW;IACX,yBAAyB;;;IAGzB;;;MAGE,aAAa;IACf;;IAEA;;MAEE,oCAAoC;MACpC,eAAe;;IAEjB;;IAEA;MACE;QACE,yBAAyB;QACzB,YAAY;;QAEZ;UACE,2BAA2B;QAC7B;MACF;IACF;;IAEA;MACE;QACE;UACE;YACE,2BAA2B;UAC7B;QACF;MACF;IACF;;EAEF;AACF;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,YAAY;AACd","sourcesContent":[".inform {\n  height: 2rem;\n  width: 25vw;\n  margin-left: 1rem;\n}\n\n/* hover effect */\n.icon-wrapper:hover .arrow-icon {\n  transform: scale(1.15);\n}\n\n.checkbox {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n;\n\n.checkbox__checked {\n  background-color: blue;\n}\n\n;\n\n.table1 {\n  font-size: small;\n  display: flex;\n}\n\nthead {\n  text-align: center;\n  word-wrap: normal;\n}\n\ntbody {\n  text-align: center;\n  word-wrap: normal;\n}\n\ntr {\n  font-size: small;\n  border: 5px transparent solid;\n\n}\n\ntd {\n  border-top: 1px solid black;\n  border: 8px solid transparent;\n  word-wrap: normal;\n}\n\n.spclbtn {\n  color: rgb(255, 81, 0);\n  border: 1px rgb(255, 81, 0) solid;\n  border-radius: 4px;\n}\n\n.spclbtn:hover {\n  background-color: rgb(255, 81, 0);\n  color: white;\n}\n\n.midheader {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  justify-content: end;\n  height: 16rem;\n}\n\n.midheadersibling {\n  display: grid;\n  border: none;\n  border-radius: 20px;\n  padding: 20px;\n  background-color: pink;\n  position: relative;\n  bottom: 12.5rem;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-expand 0.5s ease-in-out;\n  }\n}\n\n@keyframes App-logo-expand {\n  from {\n    width: 0;\n    /* start with no width */\n    opacity: 0;\n    /* start with no opacity */\n    scale: 0;\n  }\n\n  to {\n    width: 100%;\n    /* expand to full width */\n    opacity: 1;\n    /* fully visible */\n    scale: 100%;\n  }\n}\n\n.react-datepicker__day:hover {\n  background-color: #f0f4ff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.react-datepicker__day--selected {\n  background-color: #4a90e2 !important;\n  color: white;\n}\n\n.react-datepicker__day--disabled {\n  color: #ccc !important;\n  cursor: not-allowed;\n}\n\n.react-datepicker-wrapper {\n  border: none !important;\n  outline: none !important;\n}\n\n.react-datepicker__input-container input {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  /* Remove shadow if any */\n}\n\n/* Table styles */\n.table-container {\n  padding: 20px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n/* Header styles */\n.th {\n  padding: 12px;\n  text-align: left;\n  background-color: #f4f4f4;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Cell styles */\n.td {\n  padding: 12px;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Progress bar container */\n.progress-container {\n  width: 100%;\n  background-color: #e0e0e0;\n  border-radius: 5px;\n  overflow: hidden;\n  height: 10px;\n}\n\n/* Dynamic progress bar based on value */\n.progress {\n  height: 10px;\n  border-radius: 5px;\n}\n\n/* Color for different progress levels */\n.progress.high {\n  background-color: #4caf50;\n}\n\n.progress.medium {\n  background-color: #ffeb3b;\n}\n\n.progress.low {\n  background-color: #f44336;\n}\n\n.c12 {\n  display: flex;\n  justify-content: space-between;\n  background-color: #e2e8f0;\n  padding: 20px;\n  border-radius: 15px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .col-12 {\n    justify-content: center;\n    gap: 15px;\n  }\n}\n\n/* Dashboard.css */\n\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #f5f7fa;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-title {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.date-picker-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  width: 100%;\n  max-width: 600px;\n}\n\n.date-picker {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.form-label {\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.form-control {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.tableContainer {\n  width: 96%;\n\n  table {\n    width: 100%;\n    border: 1px solid #0094DE;\n\n\n    tr,\n    th,\n    td {\n      padding: 10px;\n    }\n\n    th,\n    td {\n      border: 2px solid #78c0e4 !important;\n      font-size: 12px;\n\n    }\n\n    thead {\n      tr {\n        background-color: #0094DE;\n        color: white;\n\n        th {\n          font-weight: 500 !important;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          td {\n            font-weight: 400 !important;\n          }\n        }\n      }\n    }\n\n  }\n}\n\n.boxShadow {\n  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.258);\n  background-color: #FFFFFF;\n  padding: 0px 0px 10px 0px;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(5px);\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 999;\n}\n\n.modal-content-box {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  width: 610px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
